<template>
    <div>
        <transition name="fade">
            <div id="modal-order" class="modal" :class="{'is-active': orderModal}">
                <div class="modal-background" ></div>

                <div v-if="orderStep && orderStep === -1">
                    <div class="modal-content modal-content-1">
                        <i class="fa fa-close f-modal-close" @click="butWaitModal = true"></i>
                        <img class="modallogo mt30" src="/static/images/layout/logo_FORM.png" alt="Facilimo">
                        <p class="f-modal-text-1" style="margin:auto 0 1rem;"> Iremos fazer-lhe algumas perguntas para encontrar o Profissional ideal em {{ service ? service.title : null }}.</p>
                        <div class="control" style="margin: 1rem 0 auto;">
                            <a class="button  bmod is-fullwidth" @click="orderStep++" style="border-radius:5px !important;">
                                Continuar
                            </a>
                        </div>
                    </div>
                </div>

                <div v-if="orderStep > -1 ">
                    <div class="step-content">

                        <header class="header">

                            <progress class="progress is-small is-primary" :value="orderProgress ? orderProgress : 0" max="100" style="width:50%;margin:1rem auto 2.5rem;"></progress>
                            <p class="modalsub" style="margin:1rem 0 0; font-size: 2.25rem; line-height: 1;">
	                            {{(orderStep < questions.length && !loader) ? questions[orderStep].question : statusShort}}
                            </p>

                            <i class="fa fa-close f-modal-close" @click="butWaitModal = true" style="color:#dedede;"></i>
                        </header>

                        <section class="flowsection" style=" ">

                            <div v-if="!loader" id="orderflow" class="w100" >

                                <div v-if="questions.length > 5 && orderStep < questions.length - 5">

                                    <div v-for="(q, index) in specificQuestions" :key="q.id" v-if="orderStep === index">


                                        <div v-if="q.answer.type == 'select'">

                                            <div class="-list">
                                                <div class="-line"
                                                     v-for="o in q.answer.options" v-if="o.value !== '%input%'" @click="selectinput.value = o.value; goStep(1)">
                                                    <i v-if="selectinput.value !== o.value" class="mr20 fa fa-circle-thin fa-lg has-text-primary"></i>
                                                    <i v-if="selectinput.value === o.value" class="mr20 fa fa-circle fa-lg has-text-primary"></i>
                                                    <p style="width:100%; font-size: 1.1rem; padding:0.5rem 1rem; line-height: 2rem;">{{o.description}}</p>
                                                </div>
                                                <div class="-line" v-for="o in q.answer.options" v-if="o.value === '%input%'" @click="selectinput.value = o.value">
                                                    <i v-if="selectinput.value !== o.value" class="mr20 fa fa-circle-thin fa-lg has-text-primary"></i>
                                                    <i v-if="selectinput.value === o.value" class="mr20 fa fa-circle fa-lg has-text-primary"></i>
                                                    <input v-model="selectinput.input"
                                                           :placeholder="o.description"/>
                                                </div>
                                            </div>


                                        </div>

                                        <div v-if="q.answer.type == 'checkbox'" >

                                            <div class="-list">
                                                <div class="-line"
                                                     v-for="o in q.answer.options" v-if="o.value !== '%input%'" @click="checkToggle(o.value)">
                                                    <i v-if="!checkinput.value.includes(o.value) " class="mr20 fa fa-fw fa-square-o fa-lg has-text-primary"></i>
                                                    <i v-if="checkinput.value.includes(o.value)" class="mr20 fa fa-fw fa-check-square fa-lg has-text-primary"></i>
                                                    <p style="width:100%; font-size: 1.1rem; padding:0.5rem 1rem; line-height: 2rem;">{{o.description}}</p>
                                                </div>
                                                <div class="-line" v-for="o in q.answer.options" v-if="o.value === '%input%'" @click="checkToggle(o.value)">
	                                                <i v-if="!checkinput.value.includes(o.value) " class="mr20 fa fa-fw fa-square-o fa-lg has-text-primary"></i>
	                                                <i v-if="checkinput.value.includes(o.value)" class="mr20 fa fa-fw fa-check-square fa-lg has-text-primary"></i>
                                                    <input v-model="checkinput.input"
                                                           :placeholder="o.description"/>
                                                </div>
                                            </div>


                                        </div>

                                        <div v-if="q.answer.type == 'input'" class="pt30 pb30 pl60 pr60">

                                            <input style="width:100%;border:solid 1px #dedede; font-size: 1.1rem; padding:0.5rem 1rem; line-height: 2rem;"
                                                   v-model="lead.details[q.answer.name]"
                                                   :placeholder="q.answer.placeholder"/>

                                        </div>

                                        <div v-if="q.answer.type == 'textarea'"  class="pt30 pb30 pl60 pr60" >

                                            <textarea style="border:solid 1px #dedede;" class="textarea" cols="30" rows="5" v-model="lead.details[q.answer.name]" :placeholder="q.answer.placeholder"></textarea>

                                        </div>


                                    </div>

                                </div>


                                <div v-if="orderStep === questions.length - 5" class="pt30 pb30 pl60 pr60">

                                    <div class="input-line cursor-pointer mt0 mb0 ml0 mr0" @click="ddopen !== 'when' ? ddopen = 'when': ddopen = null">
                                        <div v-if="typeof(lead.when) !== 'number'" class="input-title">
                                            <p >Selecione</p>
                                        </div>

                                        <div class="input-field">
                                            <p v-html="typeof(lead.when) === 'number' ? questions[orderStep].answer.options.filter(o=>{return o.value === lead.when})[0].description : null"> </p>
                                        </div>

                                        <div  class="input-icon">
<!--
                                            <img :class="{'flip': ddopen === 'when', 'unflip': ddopen !== 'when'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
-->
                                            <i :class="{'flip': ddopen === 'when', 'unflip': ddopen !== 'when'}" class="fa fa-angle-down has-text-primary" ></i>
                                        </div>
                                    </div>
                                    <div style="position:relative; width:100%;">
                                        <transition name="slide-fade">
                                            <div v-if="ddopen === 'when'" class="input-expanded ml0 mr0">
                                                <p v-for="i in questions[orderStep].answer.options" class="expanded-line" @click="lead.when = i.value; ddopen = null;">{{i.description}}</p>
                                            </div>
                                        </transition>
                                    </div>
                                </div>

                                <div v-if="orderStep === questions.length - 4" class="pt30 pb30 pl60 pr60">

                                    <div>
                                        <textarea v-model="lead.info" class="textarea" name="info" id="" cols="30" rows="5"
                                                  placeholder="Opcional" style="border:solid 1px #969696; padding:0.5rem;"></textarea>
                                    </div>
                                </div>

                                <div v-if="orderStep === questions.length - 3" class="pt30 pb30 pl60 pr60">

                                    <div class="input-line ml0 mr0">
<!--
                                        <input class="input-field" type="text" v-model="lead.zip_home" v-mask="'####-###'" placeholder="Código postal*">
-->
                                        <the-mask :class="badInput ? 'badinput' : ''" :mask="'####-###'" :masked="true" class="input-field" v-model="lead.zip_home" @input.native="handleZipChange" placeholder="Código postal*"/>
                                    </div>
                                    <span v-if="badInput && lead.zip_home.length < 8"><em style="font-size:0.8rem; color:#e90054;">Insira o seu código postal com os 7 dígitos</em></span>
                                    <p :class="zip_response.class" style="font-size: 0.8rem"><em>{{zip_response.message}}</em></p>


                                    <div id="map" class="mt40" v-if="!badInput && !zip_response.error">
		                                <img v-if="loadmap" :src="`https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&amp;size=610x200&amp;zoom=13&amp;key=AIzaSyBl_w8sFJDiONtBRB1ufaGaMdeO057RuDk`" border="0">
	                                </div>
                                </div>

                                <div v-if="orderStep === questions.length - 2" class="pt30 pb30 pl60 pr60">


                                    <div class="input-line ml0 mr0">
<!--
                                        <input class="input-field" ref="phone" name="phone" type="text" v-model="lead.phone" placeholder="Telefone*" v-mask="'### ### ###'">
-->
                                        <the-mask  :mask="'### ### ###'" :masked="true" class="input-field" v-model="lead.phone" placeholder="Telefone*"/>
                                    </div>

                                    <div class="input-line ml0 mr0">
                                        <input class="input-field" name="email" type="email" v-model="lead.email" placeholder="E-mail*" >
                                    </div>

                                    <p v-if="loading"><i class="fa fa-spin fa-circle-o-notch"></i></p>
                                    <p v-if="uniquePhone.message && !uniquePhone.valid">{{uniquePhone.message}}</p>

                                </div>

                                <div v-if="orderStep === questions.length - 1" class="pt30 pb30 pl60 pr60">

                                    <div  class="input-line ml0 mr0">
                                        <input class="input-field" name="name" type="text" v-model="lead.name" placeholder="Nome*" >
                                    </div>
                                </div>

                                <!--<div v-if="orderStep === questions.length" class="pt30 pb30 pl60 pr60">
                                    <p class="f-modal-text" style="font-size: 1.5rem; width:100%; padding: 2rem; text-align: center;">{{status}}</p>
                                </div>-->

                            </div>


                            <div v-if="loader" class="w100 has-text-centered"><i class="fa fa-pulse fa-spinner fa-3x"></i></div>

	                        <transition name="fade">
		                        <div v-if="badInput" class="badinput-banner">
			                        Por favor, preencha os campos obrigatórios.
		                        </div>
	                        </transition>


                        </section>

                        <footer v-if="orderStep < questions.length" class="" style="display:flex; justify-content: stretch; background-color: #f1f1f1; position:relative; border-radius: 5px;">
                            <a class="button is-primary button-foot is-fullwidth"  @click="goStep(-1)" style="border-bottom-left-radius: 5px; color: rgba(255,255,255,0.5)">
                                <i class="fa fa-angle-left "></i>&nbsp;Voltar&nbsp;&nbsp;&nbsp;&nbsp;
                            </a>
                            <a class="button is-primary button-foot is-fullwidth"  @click="goStep(1)" style="border-bottom-right-radius: 5px;">
                                &nbsp;&nbsp;&nbsp;&nbsp;Continuar&nbsp; <i class="fa fa-angle-right "></i>
                            </a>
                        </footer>
                         <footer v-else class="" style="display:flex; justify-content: stretch; background-color: #f1f1f1; position:relative; border-radius: 5px;">
                            <a class="button is-primary button-foot is-fullwidth"   style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
                                <i class="fa fa-spin fa-circle-o-notch"></i>
                            </a>
                        </footer>

                    </div>

                </div>

            </div>
        </transition>

        <transition name="fade">
            <div id="modal-butwait" class="modal" :class="{'is-active': butWaitModal}">
                <div  class="modal-background" ></div>
                <div class="modal-content modal-content-1">
                    <i class="fa fa-close f-modal-close" @click="cancelOrder()"></i>

                    <img class="modallogo mt30" src="/static/images/layout/logo_FORM.png" alt="Facilimo">

                    <p class="f-modal-text-1" style="margin:auto 0 1rem;"> Não pare agora, o seu pedido está quase terminado.</p>

                    <p class="control" style="align-self:stretch;margin:1rem 0 auto;">
                        <a class="button is-fullwidth is-success" @click="butWaitModal = false" style="border-radius:0;">
                            Continuar pedido
                        </a>
                        <a class="button bmod is-fullwidth" @click="cancelOrder()" style="border-radius:0;" >
                            Cancelar pedido
                        </a>
                    </p>

                </div>
            </div>
        </transition>


    </div>

</template>

<script>
import FakeDd from "./FakeDd";
import CheckDd from "./CheckDd";
import { TheMask } from "vue-the-mask";
import { apiUrl } from "../vars";
import helpers from "../plugins/helpers";

export default {
  components: { TheMask, FakeDd, CheckDd },

  props: ["service", "savedLead", "orderModal", "helpers"],
  data() {
    return {
      checkinput: {
        value: [],
        input: null
      },
      selectinput: {
        value: null,
        input: null
      },

      ddopen: false,

      lead: {
        details: {},
        when: null,
        info: null,
        zip_home: null,
        email: null,
        phone: null,
        name: null,
        service_id: null,
          lat: null,
          lng: null
      },

	    zip_response: {
		    message: ' ',
		    class: '',
		    error: true,
	    },

      user: null,

      status: "A enviar pedido...",
      statusShort: "A carregar...",

      badInput: false,

      orderStep: null,
      butWaitModal: false,

      responses: {},

      loader: false,
      loading: false,

      specificQuestions: [],
      defaultQuestions: [],

      uniquePhone: {},
	    center: { lat: 38.7274866, lng: -9.1421153 },
	    loadmap: false
    };
  },

  created() {
    this.getDefaultQuestions();
  },

  mounted() {
    this.orderStep = -1;
  },

  beforeRouteLeave(to, from, next) {
    this.saveIncompleteLead();
    next();
  },

  methods: {

  	handleZipChange() {
  		if (this.lead.zip_home.length === 8) {
  			this.geoCode();
  			this.checkZip();
	    }
    },

	  checkZip() {
		  axios
			  .get(apiUrl + "/api/zip/check/" + this.lead.zip_home)
			  .then(response => {
				  if (response.data.match) {
				  	this.zip_response.error = false;
					  this.zip_response.message = "O código postal é válido";
					  this.zip_response.class = "has-text-success";
				  } else if (response.data.suggestions) {
					  this.zip_response.error = true;
					  this.zip_response.message =
						  "Código postal não encontrado. Por favor introduza outro válido. (Sugestão:";
					  response.data.suggestions.forEach(s => {
						  this.zip_response.message += ` ${s.num_cod_postal}-${s.ext_cod_postal},`;
					  });
					  this.zip_response.message = this.zip_response.message.slice(0,-1);
					  this.zip_response.message += ')';
					  this.zip_response.class = "has-text-primary";
				  } else {
					  this.zip_response.error = true;
					  this.zip_response.message = "Código postal não encontrado. Por favor introduza outro válido.";
					  this.zip_response.class = "has-text-primary";
				  }
				  this.loadmap = true;
			  });
	  },

	  geoCode() {
		  axios
			  .get(apiUrl + "/api/geocode?address=" + this.lead.zip_home)
			  .then(response => {
				  if (response.data.results.length) {
					  this.center =
						  response.data.results[0].geometry.location;
					  this.lead.lat = this.center.lat;
					  this.lead.lng = this.center.lng;
				  }
				  this.loadmap = true;
			  });
	  },

      checkToggle(val) {
      let i = this.checkinput.value.indexOf(val);
      if (i !== -1) {
        this.checkinput.value.splice(i, 1);
      } else {
        this.$set(this.checkinput.value, this.checkinput.value.length, val);
      }
    },

    toggleSelect(ary, evt, prop) {
      let i = this.lead.details[prop].indexOf(evt);
      if (i !== -1) {
        ary.splice(i, 1);
      } else {
        ary.push(evt);
      }
      this.$nextTick(() => {
        this.$set(this.lead.details, prop, ary);
      });
    },

    setAnswerDd(event, question, prop) {
      this.$set(this.lead.details, question.answer.name, event[1][prop]);
    },

    goStep(by) {
      if (by > 0) {
        if (this.questions[this.orderStep].answer.type === "select") {
          if (this.selectinput.value === "%input%") {
            this.selectinput.value = 'Outro: ' + this.selectinput.input;
          }
          this.lead.details[
            this.questions[this.orderStep].answer.name
          ] = this.selectinput.value;
        }

        if (this.questions[this.orderStep].answer.type === "checkbox") {
          let i = this.checkinput.value.indexOf("%input%");
          if (i !== -1) {
            this.checkinput.value[i] = 'Outro: ' + this.checkinput.input;
          }
          this.lead.details[
            this.questions[this.orderStep].answer.name
          ] = this.checkinput.value;
        }

        if (!this.validateStep()) {
          return;
        }
        if (this.orderStep === this.questions.length - 1) {
          this.sendData();
        }
      } else {
        this.badInput = false;
      }
      this.orderStep = this.orderStep + by;
      this.selectinput = {
        value: null,
        input: null
      };
      this.checkinput = {
        value: [],
        input: null
      };
    },

    validateStep() {
      if (
        this.orderStep < this.specificQuestions.length &&
        this.orderStep >= 0
      ) {
        if (this.specificQuestions[this.orderStep].answer.required === false) {
          this.badInput = false;
          return true;
        }

        if (
          this.lead.details[this.specificQuestions[this.orderStep].answer.name]
        ) {
          if (
            ["number", "string", "object"].indexOf(
              typeof this.lead.details[
                this.specificQuestions[this.orderStep].answer.name
              ]
            ) === -1
          ) {
            this.badInput = true;
            return false;
          }
          if (
            this.lead.details[
              this.specificQuestions[this.orderStep].answer.name
            ].length === 0
          ) {
            this.badInput = true;
            return false;
          }

          this.badInput = false;
          return true;
        } else {
          this.badInput = true;
          return false;
        }
      }
      if (this.orderStep === this.questions.length - 5) {
        if (!this.lead.when) {
          this.badInput = true;
          return false;
        }
        this.badInput = false;
        return true;
      }
      if (this.orderStep === this.questions.length - 3) {
        if (!this.lead.zip_home || this.lead.zip_home.length < 8 || this.zip_response.error) {
          this.badInput = true;
          return false;
        }
        this.badInput = false;
        return true;
      }
      if (this.orderStep === this.questions.length - 2) {
        this.matchPhoneEmail();

        if (!this.lead.email || this.invalidEmail || !this.lead.phone) {
          this.badInput = true;
          return false;
        }

        if (!this.uniquePhone.valid) {
          return false;

        } else {
          this.badInput = false;
          return true;

        }

      }
      if (this.orderStep === this.questions.length - 1) {
        if (!this.lead.name) {
          this.badInput = true;
          return false;
        }
        this.badInput = false;
        return true;
      }
      return true;
    },

    sendData() {
      let that = this;
      let o = { ...this.lead };
      o.phone = "+351 " + o.phone;
      o.details = JSON.stringify(o.details);
	    o.lat = this.center.lat;
	    o.lng = this.center.lng;
      axios
        .post(`${apiUrl}/api/client`, {
          name: o.name,
          email: o.email,
          zip_home: o.zip_home,
          phone: o.phone,
	        lat: o.lat,
	        lng: o.lng
        }).then(r=>{
        	if (r.data.exists) {
        		this.$emit("client-exists");
            }
      })
        .catch(e => {
          console.error(e);
        });

      axios
        .post(apiUrl + "/api/lead/create", o)
        .then(r => {
          this.lead.id = r.data.id;
          this.lead.s = r.data.s;
          this.lead.cod = r.data.cod;
          this.$emit("completed", this.lead);
          this.finish();
        })
        .catch(e => {
          that.status = "Falha ao salvar o pedido. ";
          that.statusShort = "Erro";
        });
    },

    matchPhoneEmail() {
      this.loading = true;
      axios
        .post(apiUrl + "/api/validate/phone-email", {
          phone: "+351 " + this.lead.phone,
          email: this.lead.email
        })
        .then(response => {
          this.loading = false;
          this.uniquePhone = response.data;
          if (this.uniquePhone.valid && !this.invalidEmail) {
          	this.goStep(1);
          	this.badInput = false;
          }
        });
    },

    finish() {
      this.lead = {
        details: {},
        when: null,
        info: null,
        zip_home: null,
        email: null,
        phone: null,
        name: null,
        service_id: null
      };
      this.orderStep = -1;
      this.butWaitModal = false;
      this.$emit("closeOrderModal");
      this.$router.push({ path: "/" });
    },

    saveIncompleteLead() {
      let o = {
        service: this.service,
        orderStep: this.orderStep,
        lead: this.lead
      };
      this.$store.commit("addIncompleteLead", o);
    },

    cancelOrder() {
      if (!this.savedLead) {
        this.saveIncompleteLead();
      }
      this.orderStep = -1;
      this.lead = {
        details: {},
        when: null,
        info: null,
        zip_home: null,
        email: null,
        phone: null,
        name: null,
        service_id: null
      };
      this.butWaitModal = false;
      this.$emit("closeOrderModal");
    },

    getDefaultQuestions() {
      axios.get(apiUrl + "/api/configs/base_questions").then(r  => {
        this.defaultQuestions = r.data;
      });
    }
  },

  watch: {
    badInput: function() {
      setTimeout(() => {
        this.badInput = false;
      }, 5000);
    },

    orderModal: function() {
      if (this.orderModal) {
        document.getElementById("modal-order").onmousewheel = function(e) {
          document.getElementById("modal-order").scrollTop -= e.wheelDeltaY;
          this.preventDefault(e);
        };
        if (this.savedLead) {
          this.lead = this.savedLead.lead;
          this.orderStep = this.savedLead.orderStep;
        }
      }
    },

    butWaitModal: function() {
      if (this.butWaitModal) {
        document.getElementById("modal-butwait").onmousewheel = function(e) {
          document.getElementById("modal-butwait").scrollTop -= e.wheelDeltaY;
          this.preventDefault(e);
        };
      }
    },

    service: function () {
      this.loader = true;
      let that = this;
	    axios.get(apiUrl + "/api/configs/base_questions").then(r  => {
		    this.defaultQuestions = r.data;
		    this.defaultQuestions.forEach(e => {
			    e.question = e.question.replace("%service%", this.service.title);
			    if (e.answer.hasOwnProperty("options")) {
				    e.answer.options.forEach(f => {
					    f.description = f.description.replace(
						    "%service%",
						    this.service.title
					    );
				    });
			    }
		    });
	    });


      this.lead.service_id = this.service.id;

      axios
        .get(apiUrl + "/api/service/" + this.service.id + "/questions")
        .then(r => {
          this.specificQuestions = r.data["questions"];

          this.specificQuestions.forEach(q => {
            q.pivot_id = q.pivot.id;
          });
          helpers.sort(this.specificQuestions, "pivot_id");

          this.specificQuestions.forEach(q => {
            q.answer = JSON.parse(q.answer);
            q.question = q.question.replace("%service%", this.service.title);
            if (q.answer.hasOwnProperty("options")) {
              q.answer.options.forEach(f => {
                f.description = f.description.replace(
                  "%service%",
                  this.service.title
                );
                if (f.hasOwnProperty("placeholder"))
                  f.placeholder = f.placeholder.replace(
                    "%service%",
                    this.service.title
                  );
              });
            }
            if (q.answer.type === "checkbox") {
              this.lead.details[q.answer.name] = [];
            } else {
              this.lead.details[q.answer.name] = null;
            }
          });
          that.loader = false;
          //PSQL syntax: ﻿insert into questions (question,answer) values ('Pretende também um operador para a máquina?','{"type":"select","name":"operador","options":[description:"Sim",value:1,description:"Não",value:0])
        });
    }
  },

  computed: {
    questions() {
      return this.specificQuestions.concat(this.defaultQuestions);
    },

    invalidEmail() {
      return !this.lead.email.match(
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      );
    },

    orderProgress() {
      let p = 25;
      if (this.orderStep <= this.specificQuestions.length) {
        p += 45 / this.specificQuestions.length * this.orderStep;
      } else {
        p = 70 + 6 * (this.orderStep - this.specificQuestions.length);
      }
      return parseInt(p);
    }
  }
};
</script>
<style scoped lang="scss">
.-list {
  padding: 0;
  border: solid 1px #dedede;
  //overflow-y: auto;
  max-height: 24rem;
  > .-line:last-child {
    border-bottom: none;
  }
  > .-line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 4rem;
    padding: 1rem 3rem;
    border-bottom: solid 1px #dedede;
    cursor: pointer;

    > p {
      width: 100%;
      font-size: 1.1rem;
      padding: 0.5rem 1rem;
      line-height: 2rem;
    }

    > input {
      width: 100%;
      border: none;
      border-bottom: solid 1px #dedede;
      font-size: 1.1rem;
      padding: 0.25rem 1rem;
      line-height: 1.5rem;
    }
  }
}

.badinput {
  border: solid 1px #e90054 !important;
}

.badinput-banner {
  position: absolute;
  padding: 1rem 3rem;
  font-weight: 500;
  bottom: 0;
  width: 100%;
  background-color: #ffbb00;
  color: #535353;
  text-align: center;
}

.step-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  position: relative;
  min-height: 85vh;
  max-height: 85vh;
  width: 100%;
  max-width: 640px;
  min-width: 640px;
  border-radius: 5px;

  > .header {
    text-align: center;
    background-color: #f1f1f1;
    position: relative;
    border-radius: 5px 5px 0 0;
    padding: 2rem;
  }
}

.flowsection {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //padding:0.5rem 0;
  background-color: white;
  position: relative;
  flex-grow: 10;
}

$input-width: 400px;
$input-height: 1rem;

#orderflow {
  position: relative;
  //padding: 1rem 3rem;
  display: flex;
  height: 100%;
  flex-grow: 10;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
}

.modallogo {
  height: 3rem;
}

.modallogorpc {
  min-height: 3rem;
}

.modal-content-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background-color: #e90054;
  padding: 2rem 0;
  text-align: center;
  border-radius: 5px;
  min-height: 85vh;
  max-height: 85vh;
}

.f-modal-text-1 {
  padding: 2rem 4rem;

  text-align: left;
  color: white;
  font-size: 2rem;
  //margin: 2rem 0;
}

.f-modal-close {
  color: #eac5d9;
  position: absolute;
  font-size: 2rem;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
}

.f-input-container {
  padding: 1rem 3rem;
}

.f-modal-input {
  font-size: 1.5rem;
  width: 100%;
  border-bottom: solid 2px white;
  color: white;
}

.button {
  border-radius: 5px;
  font-size: 1.5rem;
  font-weight: 400;
  padding: 1em 2rem;
  height: 4rem;
}

.bmod {
  background-color: #eac5d9;
  color: #e90054;
}

.modal-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
  text-align: center;
  padding: 1.5rem;
}
.modal-card {
  border-radius: 5px;
}

.modal-content-2 {
  background-color: white;
  text-align: center;
  border-radius: 5px;
  min-height: 85vh;
  max-height: 85vh;
}
.input {
  font-size: 1.25rem;
  height: $input-height;
  border-radius: 5px 0 0 5px;
}

.button {
  font-size: 1.5rem;
  padding: 1rem 2rem;
  height: 4rem;
  border-radius: 0 5px 5px 0;
}

.button-foot {
  border-radius: 0;
}

.modal-button {
  border: none;
}

.mod-result {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 3rem;
  border-bottom: solid 1px #f5f5f5;
  cursor: pointer;
}

$font-size: 1.125rem;
$input-line-height: 3rem;
.input-line {
  border: solid 1px #dedede;
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: $input-line-height;
  display: flex;
  margin: 0.75rem;
  z-index: 10;
  //margin-top: 1.5rem !important;
}

.input-expanded {
  position: absolute;
  border: solid 1px #969696;
  background-color: #ffffff;
  width: 100%;
  margin: -0.75rem 0.75rem 0.75rem;
  color: black;
  padding: 0;
  //max-width:$input-width;
  z-index: 4;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
  top: $input-line-height * 0.2;
}

.expanded-line {
  position: relative;
  height: $input-line-height * 0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 1.25rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
}

.expanded-line:hover {
  color: white !important;
  background-color: #e90054 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 0 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-line p {
  text-align: left;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-field {
  //line-height:$input-line-height;
  padding: 0.675rem 1rem;
  color: black;
  font-size: $font-size;
  flex-grow: 10;
}

.input-field input {
  //line-height:$input-line-height;
  text-align: left;
  color: #4a4a4a;
  cursor: text;
  width: 100%;
  font-weight: 400;
  outline: none !important;
}

.input-field p {
  //line-height:$input-line-height;
  text-align: left;
  color: #4a4a4a;
  cursor: pointer;
  width: 100%;
  font-weight: 400;
  outline: none !important;
}

.cursor-pointer .input-field input {
  cursor: pointer;
}

.input-icon {
  line-height: 1rem;
  padding: 1rem 0.5rem;
  color: black;
  width: 2rem;
  min-width: 22px;
}

.input-icon img {
  cursor: pointer;
}

.flip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(185deg);
}

.unflip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}

@media only screen and (min-width: 769px) {
}

@media only screen and (max-width: 768px) {
  .modal-content {
    padding: 4rem 2rem;
  }
  .f-modal-text {
    color: white;
    font-size: 1.5rem;
    margin: 1rem 0;
  }

  .step-content {
    max-width: 96vw;
    min-width: 96vw;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalOrder.vue